import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
/** A grey block the size of the content that is loading. */
export function Skeleton({ className, ...props }) {
    return _jsx("div", { "aria-hidden": true, className: cn("animate-pulse rounded-md bg-muted", className), ...props });
}
//# sourceMappingURL=skeleton.js.map